module.exports = __webpack_public_path__ + "img/2.62ea4bba.png";